module.exports = __webpack_public_path__ + "img/transfer.08642e46.jpg";